define('model/ReviewClientModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Reviews data model
     *
     * @class ReviewsUserModel
     */
    return BaseModel.extend({

        urlRoot: '/review/client/',

        defaults: {
            logged_in: false,
            feedback_user_name: '',
            feedback_user_link: '',
            feedback_image_link: '',
        }

    });

});
